'use client';

import React from 'react';
import { Button } from '@ui';
import { PAGE_SIZE_OPTIONS } from './DataTableData';

export type DataTableControlsProps = {
  page: number;
  totalPages: number;
  pageSize: number;
  onPageSizeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onFirst: () => void;
  onPrev: () => void;
  onNext: () => void;
  onLast: () => void;
  /** Defaults to `PAGE_SIZE_OPTIONS` from DataTableData */
  pageSizeOptions?: number[];
};

const DataTableControls: React.FC<DataTableControlsProps> = ({
  page,
  totalPages,
  pageSize,
  onPageSizeChange,
  onFirst,
  onPrev,
  onNext,
  onLast,
  pageSizeOptions = PAGE_SIZE_OPTIONS,
}) => {
  return (
    <div className='table-controls'>
      <div className='table-rows row'>
        <label className='row'>
          <span className='hint'>Rows:</span>
          <select
            className='select select-sm'
            data-page-size
            value={String(pageSize)}
            onChange={onPageSizeChange}
          >
            {pageSizeOptions.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div className='table-pagination row'>
        <div className='gap-16'>
          <Button
            className='btn-sm btn-outline-tertiary'
            data-first
            type='button'
            label={<>&laquo;</>}
            onClick={onFirst}
            disabled={page === 1}
          />
          <Button
            className='btn-sm btn-outline-tertiary'
            data-prev
            type='button'
            label={<>&lsaquo;</>}
            onClick={onPrev}
            disabled={page === 1}
          />
        </div>
        <span className='hint' data-page-label>
          Page {page} / {totalPages}
        </span>
        <div className='gap-16'>
          <Button
            className='btn-sm btn-outline-tertiary'
            data-next
            type='button'
            label={<>&rsaquo;</>}
            onClick={onNext}
            disabled={page === totalPages}
          />
          <Button
            className='btn-sm btn-outline-tertiary'
            data-last
            type='button'
            label={<>&raquo;</>}
            onClick={onLast}
            disabled={page === totalPages}
          />
        </div>
      </div>
    </div>
  );
};

export default DataTableControls;
